import Axios from "axios";
import { IEmail } from "../common/email.model";
import { toast } from "react-toastify";

export async function sendEmail(values: IEmail) {
  await Axios.post(
    "https://gemma-sanz-portfolio.herokuapp.com/api/email",
    values
  )
    .then((res) => {
      if (res.data) {
        toast.success("Email send successfully!", {
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.warning("Oops, something went wrong!", {
          position: "bottom-right",
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      }
    })
    .catch((err) => {
      values.sendSuccessful = false;
      console.error(err);
      toast.error("Oops, something went wrong! :(", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
